import script from "./gsrcm0103-2.vue?vue&type=script&setup=true&lang=js"
export * from "./gsrcm0103-2.vue?vue&type=script&setup=true&lang=js"

import "./gsrcm0103-2.vue?vue&type=style&index=0&id=2c1bcda0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1bcda0"]])

export default __exports__